import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { combineSx, createStyleSheet, globalStyles } from "../utils/styles";

import FlaggedForSupervisor from "../../assets/supervisor_review.svg?react";
import { theme } from "../../theme";

const CheckButtonGroup = (props: {
  buttons: {
    label: string;
    count: number;
    flagged: boolean;
    onClick: () => void;
    selected: boolean;
    disabled?: boolean;
  }[];
  disabled?: boolean;
}) => {
  const { buttons, disabled } = props;

  return (
    <ToggleButtonGroup
      aria-label="Button group"
      color="primary"
      sx={styles.groupContainer}
      value={buttons.reduce<string[]>((values, button) => {
        if (!(disabled || button.disabled) && button.selected) {
          values.push(button.label);
        }
        return values;
      }, [])}
    >
      {buttons.map((button) => {
        const isDisabled = disabled || button.disabled;
        return (
          <ToggleButton
            key={button.label}
            value={button.label}
            disabled={isDisabled}
            sx={{
              ...globalStyles.flexSpace,
              position: "relative",
              overflow: "hidden",
            }}
            onClick={button.onClick}
          >
            <Box>
              <Typography
                variant="h4"
                noWrap
                sx={!isDisabled ? styles.countText : styles.countTextDisabled}
              >
                {button.count}
              </Typography>
              <Box
                sx={{
                  ...styles.buttonText,
                  backgroundColor: (theme) =>
                    !isDisabled && button.selected
                      ? theme.palette.primary.main
                      : undefined,
                }}
              >
                <Typography
                  variant="button"
                  sx={
                    !isDisabled && button.selected
                      ? combineSx(styles.buttonLabel, styles.buttonLabelSelected)
                      : styles.buttonLabel
                  }
                  noWrap
                >
                  {button.label}
                </Typography>
              </Box>
            </Box>
            {!isDisabled && button.flagged ? (
              <Box sx={styles.flaggedForSupervisor}>
                <FlaggedForSupervisor
                  fill={theme.palette.flagForSupervisor.main}
                />
              </Box>
            ) : null}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

const styles = createStyleSheet({
  groupContainer: {
    boxShadow: (theme) => theme.shadows[2],
    marginTop: 1,
  },
  buttonText: {
    marginTop: 0.5,
    borderRadius: 1000,
    px: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("desktop")]: {
      px: 0.5,
      minHeight: "20px",
    },
  },
  countText: {
    color: (theme) => theme.palette.primary.main,
  },
  countTextDisabled: {
    color: "text.disabled",
  },
  buttonLabel: {
    fontWeight: 400,
    fontSize: 14,
    [theme.breakpoints.down("desktop")]: {
      fontSize: 11,
    },
  },
  buttonLabelSelected: {
    color: "common.white",
  },
  flaggedForSupervisor: {
    position: "absolute",
    top: 0,
    right: 0,
    pointerEvents: "none",
    width: 35,
  },
});

export default CheckButtonGroup;
